import { useAtomValue } from 'jotai';

import sessionAtom, { sessionStore } from '~atoms/sessionAtom';
import { pagePaths } from '~constants';
// Explicitly not from barrel to prevent circular dependencies.
import UsersService from '~features/users/services/usersService';
import User from '~interfaces/user';
import { getService } from '~services/serviceFactory';

const usersService = getService(UsersService);

let isUpdatingUser = false;

const useSession = () => {
	const session = useAtomValue(sessionAtom);
	const isMock = import.meta.env.VITE_DEV_MOCK_API === true;

	if (
		!isUpdatingUser &&
		session.hasValidSession &&
		(!(typeof session.user === 'object') || session.user == undefined)
	) {
		isUpdatingUser = true;
		usersService
			.getCurrentUser()
			.then((user) => {
				sessionStore.setConnectUser(user);
				isUpdatingUser = false;
			})
			.catch((_apiError) => {
				isUpdatingUser = false;
				// Keep the seeded mock session usable when /users/me is unavailable.
				if (isMock) {
					return;
				}
				sessionStore.clear();
				window.location.assign(pagePaths.AuthLogin);
			});
	}

	return {
		isMock: isMock,
		user: session.user,
		hasValidSession: session.hasValidSession,
		expiresAt: session.expiresAt,
		expiresIn: session.expiresIn,
		isLoading: session.isLoading,
		bypassLoader: session.bypassLoader,
		updateSessionUser: (user: User) => {
			sessionStore.setConnectUser(user);
		},
	};
};

export default useSession;
